export default "__VITE_ASSET__DS8j2GXP__"